import { render } from "./Branch.vue?vue&type=template&id=bc9cca98"
import script from "./Branch.vue?vue&type=script&lang=js"
export * from "./Branch.vue?vue&type=script&lang=js"

import exportComponent from "/var/lib/jenkins/workspace/test-event-admin/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/views/index/components/Branch.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "bc9cca98"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('bc9cca98', __exports__)) {
    console.log('reload')
    api.reload('bc9cca98', __exports__)
  }
  
  module.hot.accept("./Branch.vue?vue&type=template&id=bc9cca98", () => {
    console.log('re-render')
    api.rerender('bc9cca98', render)
  })

}


export default __exports__